module.exports = __webpack_public_path__ + "img/zarinpal.ed8f46b5.svg";